// @ts-nocheck
import React from 'react';
import styled from 'styled-components';
import Input from 'antd/lib/input';
import Form from '../../../components/Form';
import { Section } from '../../../components/layout';
import Grid, { GridItem } from '../../../components/layout/Grid';
import JsonViewer from '../../../components/JsonViewer';
import Button from 'antd/lib/button';
import CancelButton from '../../../components/CancelButton';
const StyledSection = styled(Section).withConfig({
  displayName: "InnerForm__StyledSection",
  componentId: "sc-1twzgu-0"
})(["padding:16px;"]);
const Footer = styled(Section).withConfig({
  displayName: "InnerForm__Footer",
  componentId: "sc-1twzgu-1"
})(["padding:16px;display:flex;align-items:center;justify-content:space-between;"]);
export default ({
  onSubmit,
  onCancel,
  mdmNode
}) => <Form onSubmit={onSubmit} initialValues={mdmNode}>
    {(FormField, formikProps) => {
    const {
      handleSubmit,
      setFieldValue,
      dirty,
      isSubmitting
    } = formikProps;
    return <form onSubmit={handleSubmit}>
          <StyledSection>
            <Grid gutter="16px">
              <GridItem>
                <FormField name="name" required label="Наименование">
                  {field => <Input {...field} />}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField name="mnemocode" required label="Мнемокод">
                  {field => <Input {...field} />}
                </FormField>
              </GridItem>
              <GridItem>
                <FormField name="payload" required label="Модель">
                  {({
                name,
                value
              }) => <JsonViewer value={value} onChange={updatedValue => setFieldValue(name, updatedValue)} editable={{
                add: true,
                edit: true,
                delete: true
              }} />}
                </FormField>
              </GridItem>
            </Grid>
          </StyledSection>
          <Footer>
            <Button disabled={isSubmitting} loading={isSubmitting} type="primary" htmlType="submit">
              Сохранить
            </Button>
            <CancelButton dirty={dirty} onClick={onCancel}>
              Отменить
            </CancelButton>
          </Footer>
        </form>;
  }}
  </Form>;
